import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationDefenderOfColonistView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationDefenderOfColonistView'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'

export class UIWGamePlayerInformationDefenderOfColonistView extends UIGamePlayerInformationDefenderOfColonistView {
    protected createMyDefenderOfColonistView() {
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const defenderOfColonistX = playerInformationW * 0.809
        const defenderOfColonistY = playerInformationH * 0.71
        const defenderOfColonistW = playerInformationW * 0.0804
        const defenderOfColonistH = playerInformationH * 0.22

        const defenderOfColonistCountX = playerInformationW * 0.8943
        const defenderOfColonistCountY = defenderOfColonistY
        const defenderOfColonistCountW = playerInformationW * 0.1
        const defenderOfColonistCountH = defenderOfColonistH

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_defender)
        const iconPadding = -defenderOfColonistW * 0.0786
        this.defenderOfColonistView = new ItemCountView(defenderOfColonistX, defenderOfColonistY, defenderOfColonistW, defenderOfColonistH, this.playerInformation, texture,
            defenderOfColonistCountX, defenderOfColonistCountY, defenderOfColonistCountW, defenderOfColonistCountH, iconPadding)
        this.defenderOfColonistView.resetTextYPosition()
    }

    protected createOpponentDefenderOfColonistView() {
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const defenderOfColonistX = playerInformationW * 0.809
        const defenderOfColonistY = playerInformationH * 0.5545
        const defenderOfColonistW = playerInformationW * 0.0804
        const defenderOfColonistH = playerInformationH * 0.341

        const defenderOfColonistCountX = playerInformationW * 0.8943
        const defenderOfColonistCountY = defenderOfColonistY
        const defenderOfColonistCountW = playerInformationW * 0.1
        const defenderOfColonistCountH = defenderOfColonistH

        const iconPadding = -defenderOfColonistW * 0.0786
        this.defenderOfColonistView = new ItemCountView(defenderOfColonistX, defenderOfColonistY, defenderOfColonistW, defenderOfColonistH, this.playerInformation, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_defender),
            defenderOfColonistCountX, defenderOfColonistCountY, defenderOfColonistCountW, defenderOfColonistCountH, iconPadding)
        this.defenderOfColonistView.resetTextYPosition()
    }
}
